import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Link from '../../Core/Link';
import Container from '../../Core/Container';

const margin = '10px';

export const StyledContainer = styled(Container)`
  margin-top: 40px;

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md',
    )} - 1px)) {
    width: 100%;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin-top: 60px;
  }
`;

export const Wrapper = styled.div`
  margin: -${margin};
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md',
    )} - 1px)) {
    margin-left: 0;
    margin-right: 0;
  }
`;

export const LegalTitle = styled.h2``;

export const LegalCard = styled.div`
  margin: ${margin};
  background-color: ${themeGet('colors.white')};
  flex: 1 1 100%;
  padding: 30px 15px;
  border: 1px solid ${themeGet('colors.cta-border-grey')};

  > h2,
  p {
    margin-bottom: 20px;
  }

  ul {
    li {
      padding: 0.35rem 0;
    }
    li:not(:first-child) {
      margin-top: 0;
    }
  }

  @media only screen and (max-width: calc(${themeGet(
      'breakpoints.md',
    )} - 1px)) {
    margin-left: 0;
    margin-right: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    padding: 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex: 0 1 calc(100% / 2 - (${margin} * 2));
    padding: 50px 38px;

    > h2 {
      margin-bottom: 30px;
    }

    /* Fixes Edge */
    @supports (-ms-ime-align: auto) {
      flex: 0 1 calc(100% / 2 - (${margin} * 2) - 1px);
    }
  }

  /* Fixes IE For blog cards before medium */
  @media only screen and (min-width: ${themeGet(
      'breakpoints.md',
    )}) and (-ms-high-contrast: none),
    (-ms-high-contrast: active) {
    flex: 0 1 calc(100% / 2 - (${margin} * 2) - 1px);
  }
`;

export const LegalLink = styled(Link)`
  width: 100%;
  position: relative;
  justify-content: flex-start;

  span {
    border-bottom: 1px solid transparent;
  }

  &:hover {
    span {
      border-bottom: 1px solid ${themeGet('colors.pc-red', '#E1251B')};
    }
  }
`;
